import DomainCommon from './common';

const PricePlanService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/pricePlan`,
                resolve, reject
            });
        });
    },
    findById: (groupId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/pricePlan/${groupId}`,
                resolve, reject
            });
        });
    },
};

export default PricePlanService;



// WEBPACK FOOTER //
// ./src/service/pricePlan.js